<template lang="html">
  <div class="wrapper">
    <!-- <div class="login" v-if="!getlogin">
        <div class="log">
          <h2>Login</h2>
          <input type="text" name="" value="" placeholder="Unesi Ime">
          <input type="text" name="" value="" placeholder="Unsei Šifru">
          <button type="button" name="button">Login</button>
        </div>
    </div> -->
    <div class="adminpanel" >
      <div class="navigacija">
        <h3  @click="put('proizvodi')">Proizvodi <i v-if="putanja != 'proizvodi'" class="fas fa-plus-square"></i> <i v-if="putanja =='proizvodi'" class="fas fa-minus-square"></i></h3>
        <ul class="" v-if="$route.params.pozicija == 'proizvodi'" >
          <li v-for="kat in kategorije" :class="{active:$route.params.katid == kat.kat_id}" @click="katruta(kat.kat_id)">{{kat.kat_naziv}}</li>
        </ul>
        <h3  @click="put('saveti')">Saveti <i v-if="putanja != 'saveti'" class="fas fa-plus-square"></i> <i v-if="putanja =='saveti'" class="fas fa-minus-square"></i></h3>
        <h3  @click="put('postavke')">Postavke <i v-if="putanja != 'postavke'" class="fas fa-plus-square"></i> <i v-if="putanja =='postavke'" class="fas fa-minus-square"></i></h3>
      </div>


      <div class="user" >
        <div class="" v-if="putanja == 'saveti'">
          saveti
        </div>
        <div class="podkategorije" v-if="putanja == 'postavke'">
          <ul>
            <li @click="postavke = 'Podkategorije'" :class="{active3:postavke == 'Podkategorije'}">Podkategorije</li>
            <li @click="postavke = 'Brend'" :class="{active3:postavke == 'Brend'}">Brend</li>
            <li @click="postavke = 'Pakovanje'" :class="{active3:postavke == 'Pakovanje'}">Pakovanje</li>
          </ul>
        </div>
        <div class="postavke" v-if="putanja == 'postavke'">
          <div class="" v-if="postavke == 'Podkategorije'">
            <table v-for="kat in kategorije">
              <tr>
                <th style="width:30%">{{kat.kat_naziv}}</th>
                <th style="width:20%">Podkategorija</th>
                <th style="width:10%">
                <i @click="" title="Dodaj podkategoriju" class="fas fa-plus-square"></i>
                </th>
              </tr>
               <tr v-for="pod in podkategorije" v-if="pod.kat_id == kat.kat_id">
                <td style="width:30%"></td>
                <td style="width:20%">{{pod.pod_naziv}}</td>
                <td style="width:10%">
                <i title="Obrisi pokategoriju" @click="" class="far fa-trash-alt"></i></td>
              </tr>
          </table>

          </div>
          <div class="" v-if="postavke == 'Brend'">
            <table >
              <tr>
                <th style="width:20%">Slika</th>
                <th style="width:10%">Naziv</th>
                <th style="width:30%">Opis</th>
                <th style="width:5%">
                <i @click="" title="Dodaj pakovanje" class="fas fa-plus-square"></i>
                </th>
              </tr>
               <tr v-for="br in brand">
                 <td style="width:20%"><img :src="brandurl + br.bra_id" alt=""></td>
                <td style="width:10%">{{br.bra_naziv}}</td>
                <td style="width:30%" v-html="br.bra_tekst"></td>
                <td style="width:5%">
                <i title="Obrisi pakovanje" @click="" class="far fa-trash-alt"></i></td>
              </tr>
          </table>
            <!-- <ul>
              <li v-for="br in brand"><img :src="brandurl + br.bra_id" alt="">{{br.bra_naziv}}</li>
            </ul> -->
          </div>
          <div class="" v-if="postavke == 'Pakovanje'">
            <table >
              <tr>
                <th style="width:30%">Pakovanje</th>
                <th style="width:10%">
                <i @click="" title="Dodaj pakovanje" class="fas fa-plus-square"></i>
                </th>
              </tr>
               <tr v-for="p in pak">
                <td style="width:30%">{{p.pak_naziv}}</td>
                <td style="width:10%">
                <i title="Obrisi pakovanje" @click="" class="far fa-trash-alt"></i></td>
              </tr>
          </table>
          </div>
        </div>


        <proizvodiadmin class="" v-if="putanja == 'proizvodi'"></proizvodiadmin>

      </div>
    </div>

  </div>
  </div>
</template>

<script>
import proizvodiadmin from '@/components/proizvodiadmin'
import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {
  components: {
   proizvodiadmin
 },
  data () {
    return {
      postavke:'Brend',
      proizvodime:"",
      funkcija:"",
      katid:this.$route.params.katid,
      detalji:null,
      putanja:this.$route.params.kategorije
    }
  },
created(){
    this.putanja = this.$route.params.pozicija
},
watch:{
  $route:function(to, from){
    this.putanja = this.$route.params.pozicija
  }
},
computed:{
          ...mapGetters([
            'kategorije',
            'podkategorije',
            'brand',
            'pro',
            'allpro',
            'allpak',
            'pak',
            'brandurl',
            'getlogin'
          ]),
},
  methods:{

    katruta(id){
      this.seepro = false
      this.$router.push("/admin/"+this.putanja+"/"+id )
    },
    put(naziv){
          this.$router.push("/admin/"+naziv )

    },


  ...mapMutations([


  ]),
  ...mapActions([
    'getpro',
    'getallpro',
    'putproduct',
    'getproizvodi',
    'getsinglpk',
    'getbrand',
    'getpak'

  ]),
},
mounted(){
  this.getproizvodi()
  this.getbrand()
  this.getpak()
  }


}

</script>

<style lang="css" scoped>

details .checkbox:focus{
  margin-right: 10px
}
details[open] summary ~ * {
  animation: open .3s ease-in-out;
}
details summary::-webkit-details-marker {
  line-height: 100%;
  margin: 10px  10px 0 5px;
  color: var(--zelenoplava);
  width: 10px;
  height: 10px
}
details span{
  color: var(--zelenoplava);
}
summary:hover{
  cursor: pointer;
  color: var(--zelena)
}
summary:hover span{
  color: var(--narandzasta);
}

summary{
  outline:none;
}
/* summary:hover{
  color: white;
  background: var(--zelenoplava);
  cursor: pointer;
} */
summary:hover::-webkit-details-marker{
  color: var(--narandzasta);
}
</style>



// WEBPACK FOOTER //
// src/components/admin.vue